import { shallowMount, createLocalVue } from '@vue/test-utils';
import VueRouter from 'vue-router';
import Reviews from './Reviews';

const localVue = createLocalVue();
localVue.use(VueRouter);

const router = new VueRouter();

const createWrapper = (propsData) => {
  return shallowMount(Reviews, {
    router,
    localVue,
    propsData,
    stubs: ['dropdown']
  });
};

describe('Reviews', () => {

  test('snapshot', () => {
    let props = {
      productId: 15,
      productUrlKey: 'capri-blonde'
    };

    let wrapper = createWrapper(props);

    expect(wrapper.html()).toMatchSnapshot();
  });

  // Write more tests!
  describe.skip('computed', () => {});

  describe.skip('watch', () => {});

  describe.skip('methods', () => {});

});
